import { actionTypes } from '../actions'

const initialState = {
  elements: [],
  currentElement: {},
  docked: true,
  filteredElements: [],
  searchIndex: null,
  currentlySearching: false,
  searchText: '',
  reportWindowUrl: '',
}

export default function DataDirectoryReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.TOGGLE_DATA_DIRECTORY:
      return { ...state, docked: !state.docked }

    case actionTypes.INIT_DATA_DIRECTORY:
      return { ...state, docked: action.payload }

    case actionTypes.FETCH_ELEMENTS:
      return {
        ...state,
        elements: action.payload,
      }

    case actionTypes.SET_REPORT_WINDOW_URL:
      return {
        ...state,
        reportWindowUrl: action.payload,
      }
    case actionTypes.ELEMENTS_CACHED:
      return {
        ...state,
        elements: action.payload,
      }

    case actionTypes.SET_CURRENT_ELEMENT:
      return {
        ...state,
        currentElement: action.payload,
      }

    case actionTypes.CLEAR_CURRENT_ELEMENT:
      return {
        ...state,
        currentElement: null,
      }

    case actionTypes.FILTER_ELEMENTS:
      return { ...state, filteredElements: action.payload }

    case actionTypes.SET_FILTERING:
      return { ...state, currentlySearching: action.payload }

    case actionTypes.SET_INDEX:
      return { ...state, searchIndex: action.payload }

    case actionTypes.UPDATE_SEARCH_TEXT:
      return { ...state, searchText: action.payload }

    default:
      return state
  }
}
